import { Button, Flex, Form, InputNumber, Modal, Typography } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { OpenHrConfirmTransportationType } from 'src/components/v2/Button/BtnHrHandle';
import { ConfirmTypeEn } from 'src/constants/confirmTypeEn.enum';
import type { TransportationTicketHrConfirm } from 'src/types/hr_ticket/transportationTicket.type';
import { formatToVND } from 'src/utils/utils';
const { Text } = Typography;

interface Props {
  open: OpenHrConfirmTransportationType;
  setOpen: React.Dispatch<React.SetStateAction<OpenHrConfirmTransportationType>>;
  handleConfirmTransportation: (hrConfirmTransportation: TransportationTicketHrConfirm) => void;
}

type FormStateType = TransportationTicketHrConfirm;

const initFormState: FormStateType = {
  confirmNote: '',
  confirmType: ConfirmTypeEn.Confirmed,
  distance: undefined,
  hrConfirms: []
};

export default function HrConfirmTransportation({ open, setOpen, handleConfirmTransportation }: Props) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [formState, setFormState] = useState(initFormState);

  useEffect(() => {
    setFormState({
      ...initFormState,
      distance: open.distance
    });
  }, [open]);

  const handleSubmit = () => {
    form
      .validateFields()
      .then(() => {
        handleConfirmTransportation(formState);
        setOpen({
          isOpen: false
        });
        form.resetFields();
        setFormState(initFormState);
      })
      .catch(() => {});
  };

  const handleCancel = () => {
    setOpen({
      isOpen: false
    });
    form.resetFields();
    setFormState(initFormState);
  };

  return (
    <Modal
      title={<Text>Xác nhận vận chuyển</Text>}
      centered
      maskClosable={false}
      open={open.isOpen}
      styles={{ header: { marginBlockEnd: 16 } }}
      width={700}
      onOk={handleSubmit}
      onCancel={handleCancel}
      footer={[
        <Button key='back' onClick={handleCancel}>
          {t('action.cancel')}
        </Button>,
        <Button key='submit' type='primary' onClick={handleSubmit}>
          {t('action.submit')}
        </Button>
      ]}
    >
      <Form
        form={form}
        layout='vertical'
        fields={[
          {
            name: 'distance',
            value: formState.distance
          },
          {
            name: 'confirmNote',
            value: formState.confirmNote
          }
        ]}
      >
        <Flex vertical>
          <Form.Item
            name='distance'
            label='Số km'
            rules={[
              {
                required: true,
                message: ''
              }
            ]}
          >
            <InputNumber
              min={0}
              maxLength={12}
              controls={false}
              suffix={'Km'}
              style={{ width: '100%' }}
              formatter={(value) => formatToVND(String(value))}
              onChange={(value) => setFormState((prev) => ({ ...prev, distance: value as number }))}
            />
          </Form.Item>
          <Form.Item label='' name='confirmNote'>
            <TextArea
              onChange={(e) => setFormState((prev) => ({ ...prev, confirmNote: e.target.value }))}
              rows={4}
              placeholder={'Nhập nội dung xác nhận vận chuyển'}
            />
          </Form.Item>
        </Flex>
      </Form>
    </Modal>
  );
}
